import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export type ExternalSipProviderRequestDto = {
    name: string;
    description?: string;
    url?: string;
    port?: number;
    protocol?: string;
    username?: string;
    password?: string;
};

export type ExternalSipProviderDto = {
    id: string;
    name: string;
    description?: string | null;
    url?: string | null;
    port?: number | null;
    protocol?: string | null;
    username?: string | null;
    password?: string | null;
};

export class SipProvidersService {

    public static getSipProviders(
        xAiAgentOrganizationContext: string,
    ): CancelablePromise<Array<ExternalSipProviderDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/telecom/sip/providers',
            headers: {
                'x-ai-agent-organization-context': xAiAgentOrganizationContext,
            },
            errors: {
                400: `Bad request`,
                404: `Not found`,
                500: `Internal server error`,
            },
        });
    }

    public static createSipProvider(
        xAiAgentOrganizationContext: string,
        requestBody: ExternalSipProviderRequestDto,
    ): CancelablePromise<ExternalSipProviderDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/telecom/sip/providers',
            headers: {
                'x-ai-agent-organization-context': xAiAgentOrganizationContext,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                404: `Not found`,
                500: `Internal server error`,
            },
        });
    }

    public static updateSipProvider(
        xAiAgentOrganizationContext: string,
        id: string,
        requestBody: ExternalSipProviderRequestDto,
    ): CancelablePromise<ExternalSipProviderDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/telecom/sip/providers/{id}',
            path: {
                'id': id,
            },
            headers: {
                'x-ai-agent-organization-context': xAiAgentOrganizationContext,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                404: `Not found`,
                500: `Internal server error`,
            },
        });
    }
}
